import { EntityId } from '@factorialco/f0-react/dist/experimental'

// Type conversion helpers for workflow values
export const convertToWorkflowValue = (value: string | number | null): string => {
  if (value === null) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'number') return value.toString()
  return ''
}

export const convertEntityFromWorkflowValue = (stringValue: string): EntityId | null => {
  if (!stringValue) return null
  const asNumber = parseInt(stringValue, 10)
  return isNaN(asNumber) ? stringValue : asNumber
}
